/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsDisconnectedDeploymentStateEnum } from './vcdsDisconnectedDeploymentStateEnum';
import { CommerceModeEnum } from './commerceModeEnum';


export interface PatchDisconnectedVLRSpecOperator { 
    orgId: string;
    state?: VcdsDisconnectedDeploymentStateEnum;
    fqdn?: string;
    vcenter_id?: string;
    commerce_mode?: CommerceModeEnum;
    component_name?: string;
    /**
     * Component Version
     */
    component_version?: string;
    deactivation_code?: string;
    expiry_date?: Date;
    quantity?: number;
    sequence_number?: number;
}
export namespace PatchDisconnectedVLRSpecOperator {
}


